import { initUILabels, loginSuccess, setRefreshToken } from '../../screens/Login/actions';
import { actions as idleActions } from '../services/ReduxIdleMonitor';
import { configureAPIClient } from '../services/APIClient';

export const loginToCustomerMiddleware = (store) => (next) => (action) => {
  if (action.type === 'LOGIN_TO_CUSTOMER') {
    const params = decodeURIComponent(action.search)
      .replace('?', '')
      .split('&')
      .reduce((acc, param) => {
        const [key, value] = param.split('=');

        acc[key] = value;

        return acc;
      }, {});

    store.dispatch(loginSuccess(params.Authorization));
    store.dispatch(setRefreshToken(params.refreshToken));
    configureAPIClient(store); // TODO Might be redundant. Check and if needed - remove
    store.dispatch(initUILabels());
    store.dispatch(idleActions.start());
    setTimeout(() => {
      window.location.href = params.redirect ? params.redirect : '/';
    }, 1005);
  }

  return next(action);
};
